import {Paper, Typography, useTheme} from "@mui/material";
import Plot from "react-plotly.js";
import {formatCurrency} from "../utils/formatters";

export const ProfitDriversWaterfall = ({data}) => {
    const theme = useTheme();

    if (!data || data.length === 0) {
        return (
            <Paper style={{...theme.palette.contentPanel, padding: 20, height: 400}}>
                <Typography variant="h6">PVM Analysis</Typography>
                <Typography variant="body2" color="textSecondary" style={{marginTop: 20}}>
                    No data available
                </Typography>
            </Paper>
        );
    }

    const categories = data.map(d => d.category);
    const values = data.map(d => d.value);
    const types = data.map(d => d.type);

    const plotData = [{
        type: 'waterfall',
        orientation: 'v',
        measure: types,
        x: categories,
        textposition: 'outside',
        text: values.map(v => formatCurrency(v, 0)),
        y: values,
        connector: {
            line: {
                color: '#2c2c2cff',
                width: 1
            }
        },
        increasing: {marker: {color: theme.palette.indicator.green}},
        decreasing: {marker: {color: theme.palette.indicator.red}},
        totals: {marker: {color: theme.palette.primary.main}},
        absolute: {marker: {color: theme.palette.primary.main}},
        hovertemplate: '<b>%{x}</b><br>%{text}<extra></extra>',
        cliponaxis: false
    }];

    const layout = {
        title: {
            text: 'PVM Analysis',
            font: {size: 16}
        },
        xaxis: {
            title: '',
            tickangle: -45,
            tickfont: {size: 10},
            automargin: true
        },
        yaxis: {
            title: 'Revenue Impact ($)',
            tickformat: ',.0f',
            automargin: true
        },
        showlegend: false,
        margin: {l: 80, r: 40, t: 60, b: 150},
        height: 640,
        plot_bgcolor: 'white',
        paper_bgcolor: 'white',
        bargap: 0.1
    };

    const config = {
        displayModeBar: false,
        responsive: true
    };

    return (
        <Paper style={{...theme.palette.contentPanel, padding: 20}}>
            <Plot
                data={plotData}
                layout={layout}
                config={config}
                style={{width: '100%', height: '100%'}}
            />
        </Paper>
    );
};
